import { Component, OnInit } from '@angular/core';
import { API, UserFullDTO } from 'src/app/services/api/api';
import { ErrorService } from 'src/app/services/error.service';
import { ModalNavigationService } from 'src/app/services/gui/modal/modal-navigation.service';
import { UtilService } from 'src/app/services/util.service';
import { UntypedFormGroup } from '@angular/forms';
import { UserService } from '../../../../services/user.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'sb-comp-admin-user-edit-modal',
  templateUrl: './admin-user-edit-modal.component.html',
  styleUrls: ['./admin-user-edit-modal.component.scss'],
  standalone: false,
})
export class AdminUserEditModalComponent implements OnInit {
  formRoles: UntypedFormGroup;
  username: string;
  firstname: string;
  lastname: string;
  email: string;
  user: UserFullDTO;
  welcomeMail: boolean;
  displayMailComponent: boolean;

  constructor(
    private readonly api: API,
    private readonly modalNavigation: ModalNavigationService,
    public readonly util: UtilService,
    public readonly errorhandler: ErrorService,
    private readonly userSettings: UserService
  ) {
    this.formRoles = new UntypedFormGroup({});
    this.username = '';
    this.firstname = '';
    this.lastname = '';
    this.email = '';
    this.user = undefined;
    this.welcomeMail = false;
    this.displayMailComponent = true;
  }

  ngOnInit(): void {
    this.user = this.modalNavigation.getCurrentNavigation().data?.user;

    if (this.user) {
      this.username = this.user.username;
      this.lastname = this.user.lastname;
      this.firstname = this.user.firstname;
      this.email = this.user.email;
      this.displayMailComponent = false;
    }
  }

  onUsername($event: string) {
    if ($event?.length > 0) {
      this.username = $event;
    } else {
      this.username = null;
    }
  }

  onLastname($event: string) {
    if ($event?.length > 0) {
      this.lastname = $event;
    } else {
      this.lastname = null;
    }
  }

  onFirstname($event: string) {
    if ($event?.length > 0) {
      this.firstname = $event;
    } else {
      this.firstname = null;
    }
  }

  onEmail($event: string) {
    if ($event?.length > 0) {
      this.email = $event;
    } else {
      this.email = null;
    }
  }

  onWelcomeMail() {
    this.welcomeMail = !this.welcomeMail;
  }

  ok() {
    if (this.user) {
      // EDIT
      this.user.username = this.username;
      this.user.lastname = this.lastname;
      this.user.firstname = this.firstname;
      this.user.email = this.email;
      this.api
        ._admin_User_edit(this.user.id, this.user)
        .pipe(take(1))
        .subscribe({
          next: (e: UserFullDTO) => {
            this.close(e);
          },
          error: error => {
            this.errorhandler.errorHandler(error);
          },
        });
    } else {
      // CREATE
      const usr: UserFullDTO = this.api.createDTO('UserFullDTO');
      usr.username = this.username;
      usr.lastname = this.lastname;
      usr.firstname = this.firstname;
      usr.email = this.email;
      if (this.welcomeMail) {
        this.api
          ._admin_User_create(usr, { mailLanguage: this.userSettings.selectedLanguage() })
          .pipe(take(1))
          .subscribe({
            next: (e: UserFullDTO) => {
              this.close(e);
            },
            error: error => {
              this.errorhandler.errorHandler(error);
            },
          });
      } else {
        this.api
          ._admin_User_create(usr)
          .pipe(take(1))
          .subscribe({
            next: (e: UserFullDTO) => {
              this.close(e);
            },
            error: error => {
              this.errorhandler.errorHandler(error);
            },
          });
      }
    }
  }

  close(e: UserFullDTO) {
    this.modalNavigation.result(e);
  }

  cancel() {
    this.close(null);
  }
}
